export default {
  en: {
    MRES3: {
      title: 'MRES3 data',
      patients: 'Patients',
      appointments: 'Appointments',
      organization: 'Clinic structure',
      stages: 'Stages',
      dictionaries: 'Dictionaries',
      chatContacts: 'Chat contacts',
      subtitle: 'Received medical system data. Edit records in MRES3.',
      incomplete:
        'Initial load completeness has not been confirmed. Only received records are shown, not the entire clinic registry.',
      lastReceived: 'Last data received',
      never: 'No data received yet',
      receptionEnabled: 'Ingestion enabled',
      receptionDisabled: 'Ingestion disabled',
      loaded: 'Loaded records',
      shown: 'Showing {shown} of {total}',
      source: 'Source',
      refresh: 'Refresh data',
      search: 'Search by name, title or ID',
      find: 'Search',
      misNumber: 'MIS number',
      allMis: 'All MIS',
      noSource: 'MRES3 is not connected',
      noSourceHint:
        'This account has no MRES3 connection. Other accounts’ data is never shown here.',
      error: 'Could not load data. Please retry.',
      denied: 'The medical registry is available to account administrators.',
      retry: 'Retry',
      loading: 'Loading…',
      empty: 'No records found',
      emptyHint:
        'Check your filters. Without filters, this entity has not been loaded yet or is empty in MRES3.',
      more: 'Load more',
      details: 'All fields',
      close: 'Close',
      field: 'MRES3 field',
      value: 'Value',
      fieldSearch: 'Find a field by label or code',
      fieldCount: 'Fields: {count}',
      allColumns:
        'All {count} MRES3 fields are shown. Scroll the table horizontally.',
      patientPhones: 'Phone numbers',
      phonesNotReceived: 'No phone data received',
      version: 'Record version',
      received: 'Received in Chat',
      yes: 'Yes',
      no: 'No',
      notSet: 'Not set',
      emptyArray: 'Empty list',
      notLoaded: 'Related record has not been loaded yet',
      matches: '{count} matches',
      related: 'Open related registry',
      misId: 'MIS ID',
      sourceId: 'MRES3 ID',
      sourceTable: 'MRES3 table',
      readOnly: 'Read only',
      back: 'Reset filters',
      invalidEntity: 'This entity is unavailable in the selected section.',
      entities: {
        patients: 'Patients',
        patient_phones: 'Patient phones',
        appointments: 'Appointments',
        appointment_services: 'Appointment services',
        branches: 'Branches',
        business_units: 'Business units',
        departments: 'Departments',
        workplaces: 'Workplaces',
        appointment_stages: 'Appointment stages',
        staff: 'Staff',
        services: 'Services',
        appointment_reasons: 'Appointment reasons',
        destination_types: 'Destination types',
        resources: 'Resources',
        specializations: 'Specializations',
        diagnoses: 'Diagnoses',
        patient_statuses: 'Patient statuses',
        financial_sources: 'Financial sources',
        payment_categories: 'Payment categories',
        advertisements: 'Advertisements',
        financial_sectors: 'Financial sectors',
        service_sections: 'Service sections',
      },
    },
  },
  ru: {
    MRES3: {
      title: 'Данные MRES3',
      patients: 'Пациенты',
      appointments: 'Записи на приём',
      organization: 'Структура клиники',
      stages: 'Стадии',
      dictionaries: 'Справочники',
      chatContacts: 'Контакты чата',
      subtitle:
        'Полученные данные медицинской системы. Изменения вносятся в MRES3.',
      incomplete:
        'Полнота начальной загрузки не подтверждена. Здесь отображаются только уже полученные записи, а не весь реестр клиники.',
      lastReceived: 'Последний приём данных',
      never: 'Данные ещё не поступали',
      receptionEnabled: 'Приём данных разрешён',
      receptionDisabled: 'Приём данных выключен',
      loaded: 'Загружено записей',
      shown: 'Показано {shown} из {total}',
      source: 'Источник',
      refresh: 'Обновить данные',
      search: 'Поиск по имени, названию или ID',
      find: 'Найти',
      misNumber: 'Номер МИС',
      allMis: 'Все МИС',
      noSource: 'MRES3 не подключён',
      noSourceHint:
        'Для этого портала ещё нет подключения MRES3. Данные других порталов здесь не отображаются.',
      error: 'Не удалось загрузить данные. Повторите запрос.',
      denied: 'Просмотр медицинского реестра доступен администратору портала.',
      retry: 'Повторить',
      loading: 'Загрузка…',
      empty: 'Записи не найдены',
      emptyHint:
        'Проверьте фильтры. Если фильтров нет, этот справочник ещё не загружен или пуст в MRES3.',
      more: 'Загрузить ещё',
      details: 'Все поля',
      close: 'Закрыть',
      field: 'Поле MRES3',
      value: 'Значение',
      fieldSearch: 'Найти поле по названию или коду',
      fieldCount: 'Полей: {count}',
      allColumns:
        'Отображаются все поля MRES3: {count}. Таблица прокручивается по горизонтали.',
      patientPhones: 'Номера телефонов',
      phonesNotReceived: 'Телефоны не получены',
      version: 'Версия записи',
      received: 'Получено в Chat',
      yes: 'Да',
      no: 'Нет',
      notSet: 'Не задано',
      emptyArray: 'Пустой список',
      notLoaded: 'Связанная запись ещё не загружена',
      matches: 'Совпадений: {count}',
      related: 'Открыть связанный реестр',
      misId: 'ID в МИС',
      sourceId: 'ID MRES3',
      sourceTable: 'Таблица MRES3',
      readOnly: 'Только просмотр',
      back: 'Сбросить фильтры',
      invalidEntity: 'Этот справочник недоступен в выбранном разделе.',
      entities: {
        patients: 'Пациенты',
        patient_phones: 'Телефоны пациентов',
        appointments: 'Записи на приём',
        appointment_services: 'Услуги приёмов',
        branches: 'Филиалы',
        business_units: 'Подразделения',
        departments: 'Отделения',
        workplaces: 'Кабинеты',
        appointment_stages: 'Стадии приёмов',
        staff: 'Сотрудники',
        services: 'Услуги',
        appointment_reasons: 'Поводы назначения',
        destination_types: 'Типы назначений',
        resources: 'Ресурсы',
        specializations: 'Специализации',
        diagnoses: 'Диагнозы',
        patient_statuses: 'Статусы пациентов',
        financial_sources: 'Источники финансирования',
        payment_categories: 'Категории оплаты',
        advertisements: 'Рекламные источники',
        financial_sectors: 'Финансовые участки',
        service_sections: 'Разделы услуг',
      },
    },
  },
};
